module.exports = __webpack_public_path__ + "static/media/02.1ff036d2.svg";